export const initialState = {
  rules: [],
  competenceOrderId: null,
  siteId: null
};

export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnDetailsPropertyChanged':
      return onDetailsPropertyChanged(state, action);
    case 'OnRuleSaved':
      return onRuleSaved(state, action);
    case 'OnRuleAdded':
      return onRuleAdded(state, action);
    case 'OnRuleDeleted':
      return onRuleDeleted(state, action);
    case 'OnRuleExpanded':
      return onRuleExpanded(state, action);

    default:
      return state;
  }
}

function onInitState(state, action) {
  const { data, competenceOrderId, siteId } = action.data;
  return {
    ...state,
    rules: data.map(item => {
      return { ...item, changed: false, isExpanded: false };
    }),
    competenceOrderId: competenceOrderId,
    siteId: siteId
  };
}

function onDetailsPropertyChanged(state, action) {
  const { detailPropertyId, detailPropertyValue, detailPropertyName, detailPropertyNameValue, index } = action.payload;
  if (detailPropertyName) {
    return {
      ...state,
      rules: Object.assign([...state.rules], {
        [index]: {
          ...state.rules[index],
          [detailPropertyId]: detailPropertyValue,
          [detailPropertyName]: detailPropertyNameValue,
          changed: true
        }
      })
    };
  }

  return {
    ...state,
    rules: Object.assign([...state.rules], {
      [index]: {
        ...state.rules[index],
        [detailPropertyId]: detailPropertyValue,
        changed: true
      }
    })
  };
}

function onRuleSaved(state, action) {
  const data = action.data;
  const index = data.idx;
  const result = data.result;

  const competenceOrderRuleId = result?.data?.competenceOrderRuleSave?.competenceOrderRuleId;
  return {
    ...state,
    rules: Object.assign([...state.rules], {
      [index]: {
        ...state.rules[index],
        competenceOrderRuleId: competenceOrderRuleId,
        orderId:
          state && state.rules && state.rules.length > 0 && (state.rules[index].orderId === null || state.rules[index].orderId === 0)
            ? Math.max.apply(
                Math,
                state.rules.map(item => item.orderId)
              ) + 1
            : state.rules[index].orderId,
        changed: false,
        isExpanded: true
      }
    })
  };
}

function onRuleDeleted(state, action) {
  const { index } = action;
  const updatedRules = Object.assign([...state.rules]);
  updatedRules.splice(index, 1);
  return {
    ...state,
    rules: updatedRules
  };
}

function onRuleAdded(state) {
  const rule = {
    competenceOrderId: state.competenceOrderId,
    siteId: state.siteId,
    competenceOrderRuleId: null,
    orderId:
      state && state.rules && state.rules.length > 0
        ? Math.max.apply(
            Math,
            state.rules.map(item => item.orderId)
          ) + 1
        : 1,
    expression: '',
    approvalTypeLevelId: null,
    approvalTypeLevelSiteId: state.siteId,
    ruleStatusId: null,
    changed: true,
    isExpanded: true
  };
  const newRules = Object.assign([...state.rules]);
  newRules.push({ ...rule, changed: true });
  return {
    ...state,
    rules: newRules
  };
}

const onRuleExpanded = (state, action) => {
  const { index, isExpanded } = action;
  return {
    ...state,
    rules: Object.assign([...state.rules], {
      [index]: {
        ...state.rules[index],
        isExpanded: isExpanded
      }
    })
  };
};
